/**
 * Analytics Event Constants
 * 
 * Centralized event names for onboarding funnel and drop-off tracking.
 * Used with PostHog for product analytics.
 * 
 * Event Naming Convention:
 * - {category}_{action}_{status}
 * - Always lowercase with underscores
 * - Categories: auth, onboarding
 * - Actions: login, flow, step, sync, proposal
 * - Status: started, completed, failed, skipped, viewed
 */

// Authentication Events
export const AUTH_LOGIN_STARTED = 'auth_login_started';
export const AUTH_LOGIN_SUCCEEDED = 'auth_login_succeeded';
export const AUTH_LOGIN_FAILED = 'auth_login_failed';

// Onboarding Flow Events
export const ONBOARDING_FLOW_STARTED = 'onboarding_flow_started';
export const ONBOARDING_STEP_VIEWED = 'onboarding_step_viewed';
export const ONBOARDING_STEP_COMPLETED = 'onboarding_step_completed';
export const ONBOARDING_STEP_FAILED = 'onboarding_step_failed';
export const ONBOARDING_STEP_SKIPPED = 'onboarding_step_skipped';

// Onboarding Sync Events
export const ONBOARDING_SYNC_STARTED = 'onboarding_sync_started';
export const ONBOARDING_SYNC_COMPLETED = 'onboarding_sync_completed';
export const ONBOARDING_SYNC_FAILED = 'onboarding_sync_failed';

// Onboarding First Proposal Event
export const ONBOARDING_FIRST_PROPOSAL_CREATED = 'onboarding_first_proposal_created';

/**
 * Step IDs for onboarding checklist
 */
export const ONBOARDING_STEPS = {
  CONNECT_UPWORK: 'connect_upwork',
  JOB_FILTERS: 'job_filters',
  SYNC_JOBS: 'sync_jobs',
  AI_KNOWLEDGE: 'ai_knowledge',
  INVITE_TEAMMATE: 'invite_teammate',
  FIRST_PROPOSAL: 'first_proposal',
};

/**
 * Flow variants for A/B testing and experimentation
 */
export const FLOW_VARIANTS = {
  DEFAULT: 'default',
  FAST_PATH: 'fast_path',
  WORKSPACE_FIRST: 'workspace_first',
  DIRECT_LOGIN: 'direct_login',
};

/**
 * Event sources to track where actions originated
 */
export const EVENT_SOURCES = {
  WEB: 'web',
  EXTENSION: 'extension',
};

export default {
  // Authentication
  AUTH_LOGIN_STARTED,
  AUTH_LOGIN_SUCCEEDED,
  AUTH_LOGIN_FAILED,
  
  // Onboarding Flow
  ONBOARDING_FLOW_STARTED,
  ONBOARDING_STEP_VIEWED,
  ONBOARDING_STEP_COMPLETED,
  ONBOARDING_STEP_FAILED,
  ONBOARDING_STEP_SKIPPED,
  
  // Onboarding Sync
  ONBOARDING_SYNC_STARTED,
  ONBOARDING_SYNC_COMPLETED,
  ONBOARDING_SYNC_FAILED,
  
  // First Proposal
  ONBOARDING_FIRST_PROPOSAL_CREATED,
  
  // Constants
  ONBOARDING_STEPS,
  FLOW_VARIANTS,
  EVENT_SOURCES,
};
